import { Status } from './common';
import { CommunicationProtocol } from './communication-protocol';
import { CommunicationType, communicationTypes } from './fu-unit';

export class PortProtocol {
    id?: string;
    protocolId: string;
    extUnitId?: string;
    ceuUnitId?: string;
    portIndex: number;
    standardModbus?: ModbusSetting[];
    communicationProtocol?: CommunicationProtocol;
}

export class Port {
    port: number;
    use: Status;
    type: CommunicationType;
    name: string;
    protocol?: PortProtocol;
    timeout?: number = 900;
    retry?: number = 5;
    pollingInterval?: number = 1000;
    redundancy: boolean = false;
    redundancyUnitId?: string;
    redundancyPortIndex?: number;
    redundancyType?: RedundancyType;
    serialPortSetting?: SerialPortSetting;
    lanPortSetting?: LanPortSetting;

    constructor(index, portType: CommunicationType, oldConf?: Port) {
        this.port = index;
        this.use = oldConf ? oldConf.use : 0;
        this.type = portType;
        this.name = oldConf ? oldConf.name : '';
        this.redundancy = false;

        if (portType == communicationTypes.serial) {
            this.serialPortSetting = new SerialPortSetting();
            this.lanPortSetting = null;
        } else if (portType == communicationTypes.lan) {
            this.lanPortSetting = new LanPortSetting();
            this.serialPortSetting = null;
        }
    }
}

export class SerialPortSetting {
    baudRate: number;
    parityBit: ParityBit;
    stopBit: 1 | 1.5 | 2;
    dataBit: 7 | 8;
    duplex: Duplex;

    constructor() {
        this.baudRate = 9600;
        this.parityBit = ParityBit.None;
        this.stopBit = 1;
        this.dataBit = 8;
        this.duplex = Duplex.Full;
    }
}

export class LanPortSetting {
    localIp: string;
    remoteIp: string;
    remotePort: number;

    constructor() {
        this.localIp = '';
        this.remoteIp = '';
    }
}

export class ModbusSetting {
    id?: string;
    portProtocolId?: string;
    index: number;
    slaveId: string;
    functionCode: ModbusFunctionCode;
    startAddress: number;
    numberOfData: number;

    constructor(index, protocolId?) {
        this.index = index;
        this.portProtocolId = protocolId ?? null;
        this.slaveId = null;
        this.functionCode = null;
        this.startAddress = null;
        this.numberOfData = null;
    }
}

export const maxModbusSettings = 50;

export enum RedundancyType {
    UNDEFINED,
    Primary,
    Secondary,
}

export const BaudRateOptions = [2400, 4800, 9600, 19200, 38400, 57600, 115200];

export enum ParityBit {
    UNDEFINED,
    None,
    Even,
    Odd,
}

export enum Duplex {
    UNDEFINED,
    Full,
    Half,
}

export enum ModbusFunctionCode {
    UNDEFINED,
    '01',
    '02',
    '03',
    '04',
    '0F',
    '10 (Hex)',
}
